import { z } from 'zod';
import { createPortalToolOutputSchema } from './portal-tool.schemas';
import { INTERCEPT_TOGGLE_TOOL_NAME } from './portal-tool.constants';

export { INTERCEPT_TOGGLE_TOOL_NAME };

export const InterceptToggleActionSchema = z.enum([
  'enable-requests',
  'enable-responses',
  'enable-all',
  'disable',
  'forward',
  'forward-all',
  'drop',
  'drop-all',
  'list-queue',
]);

export const InterceptToggleInputSchema = z
  .object({
    action: InterceptToggleActionSchema,
    queueItemId: z.string().optional(),
  })
  .superRefine((value, ctx) => {
    if (
      (value.action === 'forward' || value.action === 'drop') &&
      !value.queueItemId
    ) {
      ctx.addIssue({
        code: 'custom',
        message: 'queueItemId is required for forward and drop actions',
        path: ['queueItemId'],
      });
    }
  });

export const InterceptQueueItemSummarySchema = z.object({
  queueItemId: z.string(),
  type: z.enum(['request', 'response']),
  method: z.string(),
  url: z.string(),
  status: z.string(),
});

export const InterceptToggleDataSchema = z.object({
  interceptEnabled: z.boolean(),
  interceptResponsesEnabled: z.boolean(),
  queueLength: z.number(),
  processedCount: z.number().optional(),
  queue: z.array(InterceptQueueItemSummarySchema).optional(),
});

export const InterceptToggleOutputSchema = createPortalToolOutputSchema({
  dataSchema: InterceptToggleDataSchema,
});

export type InterceptToggleInput = z.infer<typeof InterceptToggleInputSchema>;
export type InterceptToggleOutput = z.infer<typeof InterceptToggleOutputSchema>;
export type InterceptToggleData = z.infer<typeof InterceptToggleDataSchema>;
